import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "success-screen",
      class: {
        "pb-4": !_setup.isMobile,
        "px-2 pt-10 pb-6": _setup.isMobile,
        "success-screen--actions": _setup.isMobile && _vm.townUrl,
      },
      attrs: { "data-qa": "appointment_success" },
    },
    [
      _c(
        "div",
        {
          staticClass: "success-screen__mt mb-4",
          class: _setup.isMobile
            ? "px-2 success-screen__mt--mobile"
            : "pt-4 px-6 rounded elevation-1",
        },
        [
          _c("div", { staticClass: "text-h5 text--text text-center mb-8" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _setup.t(
                    "Вы записаны, подготовьтесь к приёму в бесплатном приложении МедТочка",
                    _setup.options
                  )
                ) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _setup.isMobile
            ? _c(
                VBtn,
                {
                  staticClass: "mb-8",
                  attrs: {
                    "data-qa": "success-screen_mtlink_btn",
                    color: "primary",
                    depressed: "",
                  },
                  on: { click: _setup.onDownloadMt },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_setup.t("Открыть МедТочку", _setup.options)) +
                      "\n    "
                  ),
                ]
              )
            : _c(
                "div",
                {
                  staticClass: "success-screen__qr-wrapper mb-8",
                  attrs: { "data-qa": "success-screen_mtlink_qr" },
                },
                [
                  _c("img", {
                    staticClass: "d-block",
                    attrs: {
                      "data-qa": "success-screen_mtlink_qr_img",
                      alt: "/",
                      src: "/static/_v1/pd/qr/appointment/medtochka-app.png",
                      width: "186",
                      height: "186",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "text-secondary--text text-body-1",
                      attrs: {
                        "data-qa": "success-screen_mtlink_qr_description",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _setup.t(
                              "Наведите камеру, чтобы скачать приложение",
                              _setup.options
                            )
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mb-8" },
            [
              _c("div", { staticClass: "text-subtitle-1 text--text mb-2" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _setup.t("Как подготовиться к приёму?", _setup.options)
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _vm._l(
                _setup.infoPreparationSteps,
                function (stepText, stepIndex) {
                  return _c(
                    "div",
                    { key: stepIndex, staticClass: "d-flex align-center py-2" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "success-screen__info-preparation-step text-body-2",
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(stepIndex + 1) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-body-1 ml-4" }, [
                        _vm._v(
                          "\n          " + _vm._s(stepText) + "\n        "
                        ),
                      ]),
                    ]
                  )
                }
              ),
            ],
            2
          ),
          _vm._v(" "),
          _vm._m(0),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass:
            "d-flex align-center text-decoration-none w-100 px-2 py-3",
          attrs: { type: "button", href: _vm.medtochkaUrl },
        },
        [
          _c(
            "div",
            {
              staticClass: "text-body-1 text-secondary--text text-left mr-auto",
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_setup.t("Подробности записи", _setup.options)) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("span", {
            staticClass: "ui-icon-arrow-right icon-secondary--text ml-4",
          }),
        ]
      ),
      _vm._v(" "),
      _vm.townUrl && _setup.isMobile
        ? _c(
            "div",
            {
              staticClass:
                "position-fixed w-100 bottom-0 bg-gray-0 d-flex align-center justify-end elevation-8 pa-2 ga-2",
            },
            [
              _c(
                VBtn,
                {
                  staticClass: "flex-grow-1",
                  attrs: {
                    href: _vm.townUrl,
                    color: "bg-primary",
                    depressed: "",
                  },
                },
                [
                  _c("span", { staticClass: "primary--text" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_setup.t("На главную", _setup.options)) +
                        "\n      "
                    ),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "success-screen__mt-examples" }, [
      _c("img", {
        staticClass: "success-screen__mt-examples-img",
        attrs: {
          alt: "/",
          src: "/static/_v1/pd/pictures/appointment/screen-success-mt-examples.png",
          width: "327",
          height: "301",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }